// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-calendar {
  font-size: 0.875rem;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  width: 100%;
  min-width: 284px;
  cursor: pointer;
  padding: 0.1rem 0;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.p-calendar:hover {
  background-color: #f9fafb;
}

/* Input element */
.p-inputwrapper {
  position: relative;
}
.p-inputtext {
  all: unset !important;
  width: 100% !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 0.875rem !important;
  border-radius: 4px !important;
}

.p-datepicker-trigger {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}

/* Datepicker element */
.p-datepicker {
  margin-top: 0.25rem;
  padding: 0.5rem;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  box-shadow: 0 0 0 0 #0000;
}

/* Table containing dates of a month */
.p-datepicker-calendar {
  margin: 0;
}

.p-datepicker-calendar * {
  font-size: 12px;
}
.p-datepicker-calendar th {
  text-align: center;
  line-height: 1;
}

.p-datepicker-calendar thead tr td {
  padding: 0.25rem;
}
.p-datepicker-calendar thead tr td span {
  width: 28px;
  height: 28px;
}
.p-datepicker-calendar tbody tr td {
  padding: 0.25rem;
}
.p-datepicker-calendar tbody tr td span {
  width: 28px;
  height: 28px;
}

.p-highlight {
  background-color: #004b8d;
  color: #fff;
}

.p-yearpicker-year.p-highlight,
.p-monthpicker-month.p-highlight {
  border-radius: 3px !important;
}
`, "",{"version":3,"sources":["webpack://./dev/js/components/DatePicker/DatePicker.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,6BAA6B;AAC/B","sourcesContent":[".p-calendar {\n  font-size: 0.875rem;\n  border-radius: 4px;\n  border: 1px solid #e5e7eb;\n  width: 100%;\n  min-width: 284px;\n  cursor: pointer;\n  padding: 0.1rem 0;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n}\n\n.p-calendar:hover {\n  background-color: #f9fafb;\n}\n\n/* Input element */\n.p-inputwrapper {\n  position: relative;\n}\n.p-inputtext {\n  all: unset !important;\n  width: 100% !important;\n  padding: 0.5rem 0.75rem !important;\n  font-size: 0.875rem !important;\n  border-radius: 4px !important;\n}\n\n.p-datepicker-trigger {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n\n/* Datepicker element */\n.p-datepicker {\n  margin-top: 0.25rem;\n  padding: 0.5rem;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #d1d1d1;\n  box-shadow: 0 0 0 0 #0000;\n}\n\n/* Table containing dates of a month */\n.p-datepicker-calendar {\n  margin: 0;\n}\n\n.p-datepicker-calendar * {\n  font-size: 12px;\n}\n.p-datepicker-calendar th {\n  text-align: center;\n  line-height: 1;\n}\n\n.p-datepicker-calendar thead tr td {\n  padding: 0.25rem;\n}\n.p-datepicker-calendar thead tr td span {\n  width: 28px;\n  height: 28px;\n}\n.p-datepicker-calendar tbody tr td {\n  padding: 0.25rem;\n}\n.p-datepicker-calendar tbody tr td span {\n  width: 28px;\n  height: 28px;\n}\n\n.p-highlight {\n  background-color: #004b8d;\n  color: #fff;\n}\n\n.p-yearpicker-year.p-highlight,\n.p-monthpicker-month.p-highlight {\n  border-radius: 3px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
